import { DecimalCount, NegativeStyle, NumberFormat, ThousandsSeparator, Currency } from "../griddle";
import { LocaleUtil } from "./LocaleUtil";
var NumberUtil = /** @class */ (function () {
    function NumberUtil() {
    }
    NumberUtil.decimalCountToInt = function (decimalCount) {
        switch (decimalCount) {
            case DecimalCount.DEFAULT:
                return 2;
            case DecimalCount.ZERO:
                return 0;
            case DecimalCount.ONE:
                return 1;
            case DecimalCount.TWO:
                return 2;
            case DecimalCount.THREE:
                return 3;
            case DecimalCount.FOUR:
                return 4;
            case DecimalCount.FIVE:
                return 5;
        }
    };
    NumberUtil.getNumberDisplayString = function (cell, locale) {
        if (!cell.number && cell.number != 0) {
            return "";
        }
        var num = cell.number;
        if (!cell.displayFormat) {
            return new Intl.NumberFormat(locale, {
                useGrouping: false,
                minimumFractionDigits: undefined,
                maximumFractionDigits: 2
            }).format(num);
        }
        var localeOverride = LocaleUtil.localeOverrideMap.get(locale);
        if (localeOverride) {
            locale = localeOverride;
        }
        var numberFormatType = cell.displayFormat.numberFormat;
        var showThousandsSeparator = cell.displayFormat.thousandsSeparator == ThousandsSeparator.COMMA;
        var minDecimalCount;
        var maxDecimalCount;
        if (cell.displayFormat.decimalCount && cell.displayFormat.decimalCount != DecimalCount.DEFAULT) {
            // minDecimalCount is only set if the decimal count has been manually set by the user
            minDecimalCount = maxDecimalCount = NumberUtil.decimalCountToInt(cell.displayFormat.decimalCount);
        }
        else {
            switch (numberFormatType) {
                case NumberFormat.PERCENT:
                    maxDecimalCount = 2;
                    break;
                case NumberFormat.CURRENCY:
                    break;
                default:
                    maxDecimalCount = 5;
            }
        }
        var displayValue;
        switch (numberFormatType) {
            case NumberFormat.PERCENT: {
                displayValue = new Intl.NumberFormat(locale, {
                    style: "percent",
                    useGrouping: showThousandsSeparator,
                    minimumFractionDigits: minDecimalCount,
                    maximumFractionDigits: maxDecimalCount
                }).format(num);
                break;
            }
            case NumberFormat.CURRENCY: {
                var negativeStyle = void 0;
                if (cell.displayFormat.negativeStyle == NegativeStyle.PAREN_BLACK ||
                    cell.displayFormat.negativeStyle == NegativeStyle.PAREN_RED) {
                    negativeStyle = "accounting";
                }
                var cellCurrency = cell.displayFormat.currency;
                if (cellCurrency) {
                    // special handling for japanese yen and korean won
                    if (cellCurrency == Currency.KRW || cellCurrency == Currency.JPY) {
                        minDecimalCount = maxDecimalCount = 0;
                    }
                    var currencyCode = LocaleUtil.currencyStringMap.get(cellCurrency);
                    displayValue = new Intl.NumberFormat(locale, {
                        style: "currency",
                        currency: currencyCode,
                        currencySign: negativeStyle,
                        useGrouping: showThousandsSeparator,
                        minimumFractionDigits: minDecimalCount,
                        maximumFractionDigits: maxDecimalCount
                    }).format(num);
                    break;
                }
                // intentionally falls through to default if there is no currency code
            }
            default: {
                displayValue = new Intl.NumberFormat(locale, {
                    useGrouping: showThousandsSeparator,
                    minimumFractionDigits: minDecimalCount,
                    maximumFractionDigits: maxDecimalCount
                }).format(num);
                break;
            }
        }
        return displayValue;
    };
    return NumberUtil;
}());
export { NumberUtil };
//# sourceMappingURL=NumberUtil.js.map